export type TagResponse = {
  connectedAsset: string;
  dataType: string;
  displayName: string;
  gatewayId: string;
  gatewayName?: string;
  hidden: boolean;
  siteName?: string;
  id: string;
  rawInputName: string;
  rawUnit: string;
  connectedAssetId: string;
  forwarded?: boolean;
  siteForwardedFrom?: string;
  gatewayForwardedFrom?: string;
  parentType?: string;
  value?: string | number;
};

export enum LabelingTypeEnum {
  VALUE = 'value',
  LABEL = 'label',
  VALUE_LABEL = 'value_label',
}
